{
  "country": "Algeria",
  "country_ar": "الجزائر",
  "total_wilayas": 69,
  "last_updated": "2025-11-22",
  "version": "1.1.0",
  "description": "Complete dataset of Algeria's 69 wilayas including the 10 new wilayas established in November 2025",
  "note": "Coordinates represent approximate location of wilaya capital cities",
  "regions": {
    "north": "Tell/Mediterranean region - 19 wilayas",
    "high_plateaus": "High Plateaus region - 17 wilayas",
    "sahara": "Saharan region - 33 wilayas"
  },
  "wilayas": [
    {
      "id": 1,
      "name": "Adrar",
      "name_ar": "أدرار",
      "established": "1984",
      "latitude": 27.9716,
      "longitude": -0.1870,
      "elevation": 276,
      "region": "Sahara",
      "area_km2": 427968,
      "phone_code": "049",
      "postal_code": "01000",
      "population_approx": 402000,
      "notable_features": ["Tuat Oases", "Gourara", "Touat region", "Traditional irrigation systems (foggaras)"]
    },
    {
      "id": 2,
      "name": "Chlef",
      "name_ar": "الشلف",
      "established": "1984",
      "latitude": 36.1646,
      "longitude": 1.3347,
      "elevation": 143
    },
    {
      "id": 3,
      "name": "Laghouat",
      "name_ar": "الأغواط",
      "established": "1984",
      "latitude": 33.8000,
      "longitude": 2.8833,
      "elevation": 765
    },
    {
      "id": 4,
      "name": "Oum El Bouaghi",
      "name_ar": "أم البواقي",
      "established": "1984",
      "latitude": 35.8753,
      "longitude": 7.1133,
      "elevation": 893
    },
    {
      "id": 5,
      "name": "Batna",
      "name_ar": "باتنة",
      "established": "1984",
      "latitude": 35.5558,
      "longitude": 6.1742,
      "elevation": 1048
    },
    {
      "id": 6,
      "name": "Béjaïa",
      "name_ar": "بجاية",
      "established": "1984",
      "latitude": 36.7525,
      "longitude": 5.0553,
      "elevation": 1
    },
    {
      "id": 7,
      "name": "Biskra",
      "name_ar": "بسكرة",
      "established": "1984",
      "latitude": 34.8503,
      "longitude": 5.7242,
      "elevation": 124
    },
    {
      "id": 8,
      "name": "Béchar",
      "name_ar": "بشار",
      "established": "1984",
      "latitude": 31.6167,
      "longitude": -2.2167,
      "elevation": 806
    },
    {
      "id": 9,
      "name": "Blida",
      "name_ar": "البليدة",
      "established": "1984",
      "latitude": 36.4800,
      "longitude": 2.8283,
      "elevation": 260
    },
    {
      "id": 10,
      "name": "Bouira",
      "name_ar": "البويرة",
      "established": "1984",
      "latitude": 36.3689,
      "longitude": 3.9000,
      "elevation": 519
    },
    {
      "id": 11,
      "name": "Tamanrasset",
      "name_ar": "تمنراست",
      "established": "1984",
      "latitude": 22.7850,
      "longitude": 5.5228,
      "elevation": 1377,
      "region": "Sahara",
      "area_km2": 556200,
      "phone_code": "029",
      "postal_code": "11000",
      "population_approx": 200000,
      "notable_features": ["Hoggar Mountains", "Assekrem", "Gateway to Sahara", "Tuareg culture", "Largest wilaya by area"]
    },
    {
      "id": 12,
      "name": "Tébessa",
      "name_ar": "تبسة",
      "established": "1984",
      "latitude": 35.4042,
      "longitude": 8.1242,
      "elevation": 813
    },
    {
      "id": 13,
      "name": "Tlemcen",
      "name_ar": "تلمسان",
      "established": "1984",
      "latitude": 34.8781,
      "longitude": -1.3150,
      "elevation": 842
    },
    {
      "id": 14,
      "name": "Tiaret",
      "name_ar": "تيارت",
      "established": "1984",
      "latitude": 35.3711,
      "longitude": 1.3225,
      "elevation": 1086
    },
    {
      "id": 15,
      "name": "Tizi Ouzou",
      "name_ar": "تيزي وزو",
      "established": "1984",
      "latitude": 36.7019,
      "longitude": 4.0500,
      "elevation": 200
    },
    {
      "id": 16,
      "name": "Algiers",
      "name_ar": "الجزائر",
      "established": "1984",
      "latitude": 36.7538,
      "longitude": 3.0588,
      "elevation": 424,
      "region": "North",
      "area_km2": 809,
      "phone_code": "021",
      "postal_code": "16000",
      "population_approx": 3000000,
      "capital": true,
      "coastal": true,
      "notable_features": ["Capital city", "Casbah (UNESCO)", "Notre Dame d'Afrique", "Port of Algiers", "Mediterranean coast"]
    },
    {
      "id": 17,
      "name": "Djelfa",
      "name_ar": "الجلفة",
      "established": "1984",
      "latitude": 34.6703,
      "longitude": 3.2500,
      "elevation": 1144
    },
    {
      "id": 18,
      "name": "Jijel",
      "name_ar": "جيجل",
      "established": "1984",
      "latitude": 36.8200,
      "longitude": 5.7667,
      "elevation": 5
    },
    {
      "id": 19,
      "name": "Sétif",
      "name_ar": "سطيف",
      "established": "1984",
      "latitude": 36.1833,
      "longitude": 5.4000,
      "elevation": 1081
    },
    {
      "id": 20,
      "name": "Saïda",
      "name_ar": "سعيدة",
      "established": "1984",
      "latitude": 34.8333,
      "longitude": 0.1500,
      "elevation": 748
    },
    {
      "id": 21,
      "name": "Skikda",
      "name_ar": "سكيكدة",
      "established": "1984",
      "latitude": 36.8667,
      "longitude": 6.9167,
      "elevation": 7
    },
    {
      "id": 22,
      "name": "Sidi Bel Abbès",
      "name_ar": "سيدي بلعباس",
      "established": "1984",
      "latitude": 35.1900,
      "longitude": -0.6400,
      "elevation": 485
    },
    {
      "id": 23,
      "name": "Annaba",
      "name_ar": "عنابة",
      "established": "1984",
      "latitude": 36.9000,
      "longitude": 7.7667,
      "elevation": 4
    },
    {
      "id": 24,
      "name": "Guelma",
      "name_ar": "قالمة",
      "established": "1984",
      "latitude": 36.4633,
      "longitude": 7.4331,
      "elevation": 290
    },
    {
      "id": 25,
      "name": "Constantine",
      "name_ar": "قسنطينة",
      "established": "1984",
      "latitude": 36.3650,
      "longitude": 6.6147,
      "elevation": 694
    },
    {
      "id": 26,
      "name": "Médéa",
      "name_ar": "المدية",
      "established": "1984",
      "latitude": 36.2642,
      "longitude": 2.7539,
      "elevation": 920
    },
    {
      "id": 27,
      "name": "Mostaganem",
      "name_ar": "مستغانم",
      "established": "1984",
      "latitude": 35.9306,
      "longitude": 0.0892,
      "elevation": 108
    },
    {
      "id": 28,
      "name": "M'Sila",
      "name_ar": "المسيلة",
      "established": "1984",
      "latitude": 35.7058,
      "longitude": 4.5425,
      "elevation": 441
    },
    {
      "id": 29,
      "name": "Mascara",
      "name_ar": "معسكر",
      "established": "1984",
      "latitude": 35.3833,
      "longitude": 0.1500,
      "elevation": 590
    },
    {
      "id": 30,
      "name": "Ouargla",
      "name_ar": "ورقلة",
      "established": "1984",
      "latitude": 31.9500,
      "longitude": 5.3333,
      "elevation": 157
    },
    {
      "id": 31,
      "name": "Oran",
      "name_ar": "وهران",
      "established": "1984",
      "latitude": 35.6969,
      "longitude": -0.6331,
      "elevation": 90,
      "region": "North",
      "area_km2": 2114,
      "phone_code": "041",
      "postal_code": "31000",
      "population_approx": 1500000,
      "coastal": true,
      "notable_features": ["Second largest city", "Santa Cruz Fort", "Mediterranean port", "Ahmed Zabana Stadium"]
    },
    {
      "id": 32,
      "name": "El Bayadh",
      "name_ar": "البيض",
      "established": "1984",
      "latitude": 33.6833,
      "longitude": 1.0167,
      "elevation": 1341
    },
    {
      "id": 33,
      "name": "Illizi",
      "name_ar": "إليزي",
      "established": "1984",
      "latitude": 26.5000,
      "longitude": 8.4667,
      "elevation": 559
    },
    {
      "id": 34,
      "name": "Bordj Bou Arréridj",
      "name_ar": "برج بوعريريج",
      "established": "1984",
      "latitude": 36.0686,
      "longitude": 4.7678,
      "elevation": 927
    },
    {
      "id": 35,
      "name": "Boumerdès",
      "name_ar": "بومرداس",
      "established": "1984",
      "latitude": 36.7606,
      "longitude": 3.4722,
      "elevation": 5
    },
    {
      "id": 36,
      "name": "El Tarf",
      "name_ar": "الطارف",
      "established": "1984",
      "latitude": 36.7667,
      "longitude": 8.3000,
      "elevation": 22
    },
    {
      "id": 37,
      "name": "Tindouf",
      "name_ar": "تندوف",
      "established": "1984",
      "latitude": 27.8000,
      "longitude": -8.1333,
      "elevation": 450
    },
    {
      "id": 38,
      "name": "Tissemsilt",
      "name_ar": "تيسمسيلت",
      "established": "1984",
      "latitude": 35.6050,
      "longitude": 1.8106,
      "elevation": 871
    },
    {
      "id": 39,
      "name": "El Oued",
      "name_ar": "الوادي",
      "established": "1984",
      "latitude": 33.3667,
      "longitude": 6.8667,
      "elevation": 64
    },
    {
      "id": 40,
      "name": "Khenchela",
      "name_ar": "خنشلة",
      "established": "1984",
      "latitude": 35.4361,
      "longitude": 7.1428,
      "elevation": 1200
    },
    {
      "id": 41,
      "name": "Souk Ahras",
      "name_ar": "سوق أهراس",
      "established": "1984",
      "latitude": 36.2833,
      "longitude": 7.9500,
      "elevation": 695
    },
    {
      "id": 42,
      "name": "Tipaza",
      "name_ar": "تيبازة",
      "established": "1984",
      "latitude": 36.5500,
      "longitude": 2.4500,
      "elevation": 30
    },
    {
      "id": 43,
      "name": "Mila",
      "name_ar": "ميلة",
      "established": "1984",
      "latitude": 36.4503,
      "longitude": 6.2642,
      "elevation": 451
    },
    {
      "id": 44,
      "name": "Aïn Defla",
      "name_ar": "عين الدفلى",
      "established": "1984",
      "latitude": 36.2639,
      "longitude": 1.9681,
      "elevation": 299
    },
    {
      "id": 45,
      "name": "Naâma",
      "name_ar": "النعامة",
      "established": "1984",
      "latitude": 33.2667,
      "longitude": -0.3167,
      "elevation": 1166
    },
    {
      "id": 46,
      "name": "Aïn Témouchent",
      "name_ar": "عين تموشنت",
      "established": "1984",
      "latitude": 35.2989,
      "longitude": -1.1397,
      "elevation": 232
    },
    {
      "id": 47,
      "name": "Ghardaïa",
      "name_ar": "غرداية",
      "established": "1984",
      "latitude": 32.4906,
      "longitude": 3.6739,
      "elevation": 469
    },
    {
      "id": 48,
      "name": "Relizane",
      "name_ar": "غليزان",
      "established": "1984",
      "latitude": 35.7372,
      "longitude": 0.5558,
      "elevation": 89
    },
    {
      "id": 49,
      "name": "Timimoune",
      "name_ar": "تيميمون",
      "established": "2019",
      "latitude": 29.2667,
      "longitude": 0.2333,
      "elevation": 311
    },
    {
      "id": 50,
      "name": "Bordj Badji Mokhtar",
      "name_ar": "برج باجي مختار",
      "established": "2019",
      "latitude": 21.3272,
      "longitude": 0.9542,
      "elevation": 397
    },
    {
      "id": 51,
      "name": "Ouled Djellal",
      "name_ar": "أولاد جلال",
      "established": "2019",
      "latitude": 34.4139,
      "longitude": 4.9686,
      "elevation": 132
    },
    {
      "id": 52,
      "name": "In Salah",
      "name_ar": "عين صالح",
      "established": "2019",
      "latitude": 27.2000,
      "longitude": 2.4667,
      "elevation": 268
    },
    {
      "id": 53,
      "name": "In Guezzam",
      "name_ar": "عين قزام",
      "established": "2019",
      "latitude": 19.5667,
      "longitude": 5.7667,
      "elevation": 397
    },
    {
      "id": 54,
      "name": "Touggourt",
      "name_ar": "تقرت",
      "established": "2019",
      "latitude": 33.1067,
      "longitude": 6.0589,
      "elevation": 85
    },
    {
      "id": 55,
      "name": "Djanet",
      "name_ar": "جانت",
      "established": "2019",
      "latitude": 24.5542,
      "longitude": 9.4844,
      "elevation": 1053
    },
    {
      "id": 56,
      "name": "El M'Ghair",
      "name_ar": "المغير",
      "established": "2019",
      "latitude": 33.9667,
      "longitude": 5.9167,
      "elevation": 73
    },
    {
      "id": 57,
      "name": "Béni Abbès",
      "name_ar": "بني عباس",
      "established": "2019",
      "latitude": 30.1333,
      "longitude": -2.1667,
      "elevation": 503
    },
    {
      "id": 58,
      "name": "El Menia",
      "name_ar": "المنيعة",
      "established": "2019",
      "latitude": 30.5833,
      "longitude": 2.8667,
      "elevation": 396
    },
    {
      "id": 59,
      "name": "Aflou",
      "name_ar": "أفلو",
      "established": "2025",
      "latitude": 34.1125,
      "longitude": 2.1000,
      "elevation": 1426,
      "region": "High Plateaus",
      "area_km2": 2500,
      "phone_code": "027",
      "postal_code": "03400",
      "population_approx": 120000,
      "parent_wilaya": "Laghouat",
      "new_2025": true,
      "notable_features": ["High altitude city", "Agricultural region", "Berber culture"]
    },
    {
      "id": 60,
      "name": "Barika",
      "name_ar": "بريكة",
      "established": "2025",
      "latitude": 35.3833,
      "longitude": 5.3667,
      "elevation": 455,
      "region": "High Plateaus",
      "area_km2": 1800,
      "phone_code": "033",
      "postal_code": "05200",
      "population_approx": 180000,
      "parent_wilaya": "Batna",
      "new_2025": true,
      "notable_features": ["Agricultural hub", "Ziban region", "Date palm cultivation"]
    },
    {
      "id": 61,
      "name": "Ksar Chellala",
      "name_ar": "قصر الشلالة",
      "established": "2025",
      "latitude": 35.2119,
      "longitude": 2.3158,
      "elevation": 876,
      "region": "High Plateaus",
      "area_km2": 1600,
      "phone_code": "046",
      "postal_code": "14200",
      "population_approx": 100000,
      "parent_wilaya": "Tiaret",
      "new_2025": true,
      "notable_features": ["Agricultural center", "Cereal production", "Livestock farming"]
    },
    {
      "id": 62,
      "name": "Messaad",
      "name_ar": "مسعد",
      "established": "2025",
      "latitude": 34.1544,
      "longitude": 3.5036,
      "elevation": 775,
      "region": "High Plateaus",
      "area_km2": 2000,
      "phone_code": "027",
      "postal_code": "17300",
      "population_approx": 90000,
      "parent_wilaya": "Djelfa",
      "new_2025": true,
      "notable_features": ["Steppe region", "Pastoralism", "Desert gateway"]
    },
    {
      "id": 63,
      "name": "Aïn Oussara",
      "name_ar": "عين وسارة",
      "established": "2025",
      "latitude": 35.4519,
      "longitude": 2.9069,
      "elevation": 820,
      "region": "High Plateaus",
      "area_km2": 1700,
      "phone_code": "027",
      "postal_code": "17400",
      "population_approx": 110000,
      "parent_wilaya": "Djelfa",
      "new_2025": true,
      "notable_features": ["Strategic location", "Agricultural activity", "Transit hub"]
    },
    {
      "id": 64,
      "name": "Bou Saâda",
      "name_ar": "بوسعادة",
      "established": "2025",
      "latitude": 35.2194,
      "longitude": 4.1861,
      "elevation": 460,
      "region": "High Plateaus",
      "area_km2": 2200,
      "phone_code": "035",
      "postal_code": "28200",
      "population_approx": 140000,
      "parent_wilaya": "M'Sila",
      "new_2025": true,
      "notable_features": ["Oasis city", "Cultural heritage", "Tourism destination", "Gateway to Sahara"]
    },
    {
      "id": 65,
      "name": "El Abiodh Sidi Cheikh",
      "name_ar": "الأبيض سيدي الشيخ",
      "established": "2025",
      "latitude": 32.8931,
      "longitude": 0.5486,
      "elevation": 1085,
      "region": "Sahara",
      "area_km2": 3500,
      "phone_code": "049",
      "postal_code": "32300",
      "population_approx": 60000,
      "parent_wilaya": "El Bayadh",
      "new_2025": true,
      "notable_features": ["Religious heritage", "Zawiya", "Desert landscapes", "Nomadic traditions"]
    },
    {
      "id": 66,
      "name": "El Kantara",
      "name_ar": "القنطرة",
      "established": "2025",
      "latitude": 35.1833,
      "longitude": 5.7000,
      "elevation": 415,
      "region": "High Plateaus",
      "area_km2": 1400,
      "phone_code": "033",
      "postal_code": "05450",
      "population_approx": 80000,
      "parent_wilaya": "Biskra",
      "new_2025": true,
      "notable_features": ["Gateway of the Desert", "Natural gorge", "Roman bridge", "Tourism"]
    },
    {
      "id": 67,
      "name": "Bir El Ater",
      "name_ar": "بئر العاتر",
      "established": "2025",
      "latitude": 34.7450,
      "longitude": 8.0597,
      "elevation": 860,
      "region": "High Plateaus",
      "area_km2": 1900,
      "phone_code": "037",
      "postal_code": "12400",
      "population_approx": 95000,
      "parent_wilaya": "Tébessa",
      "new_2025": true,
      "notable_features": ["Mining center", "Phosphate deposits", "Border proximity"]
    },
    {
      "id": 68,
      "name": "Ksar El Boukhari",
      "name_ar": "قصر البخاري",
      "established": "2025",
      "latitude": 35.8889,
      "longitude": 2.7492,
      "elevation": 442,
      "region": "High Plateaus",
      "area_km2": 1500,
      "phone_code": "025",
      "postal_code": "26200",
      "population_approx": 105000,
      "parent_wilaya": "Médéa",
      "new_2025": true,
      "notable_features": ["Agricultural region", "Cereal cultivation", "Livestock"]
    },
    {
      "id": 69,
      "name": "El Aricha",
      "name_ar": "العريشة",
      "established": "2025",
      "latitude": 31.9167,
      "longitude": -1.1167,
      "elevation": 950,
      "region": "Sahara",
      "area_km2": 2800,
      "phone_code": "049",
      "postal_code": "08400",
      "population_approx": 45000,
      "parent_wilaya": "Béchar",
      "new_2025": true,
      "notable_features": ["Border town", "Trade hub", "Desert landscapes", "Cross-border commerce"]
    }
  ]
}